export function htmlEscapeDecode(str: string): string {
  const mapSymbols: Record<string, string> = {
    '"': '&quot;',
    "'": '&#039;'
  };

  return str.replace(/["']/g, (m) => mapSymbols[m] || m);
}
